import { useState } from "react"
import PatienCard from "../../../components/cards/PatientCard"
import { PatientFileModal } from "../../../components/cards/PatientFileModal"
import {
  orderPatientsByDate,
  usePredictionByPatients,
  useScoresByPatients,
  useStudyQuery
} from "../../../hooks/useStudies"
import {
  usePostOpSurveys,
  usePreOpSurveys,
  useQOLSurveys,
  useStudyQueryDetails
} from "../../../hooks/useStudyDetails"
import { IPatient } from "../../../types/types"

interface IProps {}

const baseItemStyle =
  "flex px-2 text-slate-600 text-normal w-full bg-cortexx-50 border-b transition-colors ease-in-out duration-400 hover:bg-sumo-400 items-center"

export const Files = (props: IProps) => {
  const { data: patientScores } = useScoresByPatients()
  const { data: patientPredictions } = usePredictionByPatients()
  const { data: study } = useStudyQuery(orderPatientsByDate)

  const [patientId, setPatientId] = useState(
    study?.patients.length ? study?.patients[0].id.toString() : ""
  )
  const { data: studyDetails } = useStudyQueryDetails(patientId || "")
  const { data: preOpSurveys } = usePreOpSurveys(patientId || "")
  const { data: qOLSurveys } = useQOLSurveys(patientId || "")
  const { data: postOpSurveys } = usePostOpSurveys(patientId || "")

  const [openPatientFileModal, setOpenPatientFileModal] = useState(false)

  const openFileModal = (_patientId: string) => {
    setPatientId(_patientId)
    setOpenPatientFileModal(true)
  }

  const renderPatientListHeader = () => (
    <div className="flex flex-row text-slate-600 text-normal font-semibold w-full py-4 md:py-6 px-2 xl:text-base text-xs">
      <div className="flex flex-row w-[65%]">
        <div className="flex flex-row w-[40%]">Date de chirurgie</div>
        <div className="flex flex-row w-[30%]">Nom</div>
        <div className="flex flex-row w-[30%]">Prénom</div>
      </div>
      <div className="flex flex-row w-[35%]">Action</div>
    </div>
  )

  const renderPatientListItem = (patient: IPatient) => (
    <div className={baseItemStyle}>
      <button
        className="flex flex-row w-[65%] py-4 md:py-5"
        onClick={() => setPatientId(patient.id.toString())}
      >
        <div className="flex flex-row w-[40%]">{patient.surgery_date}</div>
        <div className="flex flex-row w-[30%]">
          {patient.surname.toLocaleUpperCase()}
        </div>
        <div className="flex flex-row w-[30%]">{patient.name}</div>
      </button>
      <div className="flex flex-row w-[35%] gap-2">
        <button
          className="bg-sumo-500 text-sumo-50 rounded-xl px-4 py-2 text-sm font-bold"
          onClick={() => openFileModal(patient.id.toString())}
        >
          Compléter dossier
        </button>
      </div>
    </div>
  )

  return (
    <div className="flex flex-col w-full h-full justify-start items-start bg-sumo-50 flex-1 pl-12 pr-4 py-6 overflow-auto">
      <div className="flex w-full">
        <div className="flex w-1/2 justify-start text-slate-900 font-semibold">
          <p>DOSSIERS PATIENTS</p>
        </div>
      </div>
      <div className="flex w-full">
        <div className="flex flex-col w-1/2 pr-8">
          <div className="flex flex-col w-full">
            <div>{renderPatientListHeader()}</div>
          </div>
          <div className="flex flex-col w-full h-full gap-2">
            <div>{study?.patients.map(renderPatientListItem)}</div>
          </div>
        </div>
        <div className="flex flex-col w-1/2">
          <PatienCard
            patientId={patientId}
            patientName={studyDetails?.patient.name ?? ""}
            patientSurname={studyDetails?.patient.surname ?? ""}
            surgeryDate={new Date(studyDetails?.patient.surgery_date ?? "")}
            patient_surveys={studyDetails?.patient_surveys}
            preOpSurveys={preOpSurveys}
            qOLSurveys={qOLSurveys}
            postOpSurveys={postOpSurveys}
            patientScores={patientScores}
            predictions={patientPredictions}
          />
        </div>
      </div>
      {openPatientFileModal ? (
        <PatientFileModal
          closeModal={() => {
            setOpenPatientFileModal(false)
          }}
          patientId={patientId}
        />
      ) : null}
    </div>
  )
}
